import * as Localization from "expo-localization";
import i18n from "i18n-js";

const ja = {
  config: "設定",
  playMode: "対戦モード",
  boardSize: "ボードのサイズ",
  changeImage: "画像の変更",
  saveConfig: "設定を保存",
  turnMessage: "の番です。",
  drawMessage: "引き分けです！",
  winMessage: "の勝ちです！",
  playAgain: "もう一回あそぶ",
};

type TranslationKey = keyof typeof ja;

const en: Record<TranslationKey, string> = {
  config: "Config",
  playMode: "Play Mode",
  boardSize: "Board Size",
  changeImage: "Change Image",
  saveConfig: "Save Config",
  turnMessage: "'s Turn.",
  drawMessage: "Draw!!",
  winMessage: "Win!!",
  playAgain: "Play Again",
};

i18n.translations = {
  ja,
  en,
};
i18n.locale = Localization.locale;
i18n.fallbacks = true;

export const trans = (key: TranslationKey): string => {
  return i18n.t(key);
};
